import React, { useMemo, useCallback } from 'react';
import { svgSprite } from '../../../../../hybrid/wrappers';
import { handleClick } from '../../../helpers';
import SubMenuOffice from '../SubMenuOffice/SubMenuOffice';
import css from './MenuOfficeItem.module.scss';
import classnames from 'classnames';

const MenuOfficeItem = ({ menuItem, submenu, active, setSubmenu, toggleMenu }) => {
    const isActive = useMemo(() => active.active.includes(menuItem.name), [active?.active, menuItem?.name]);
    const openSub = useCallback(
        (item) => {
            if (submenu?.asLink === item.asLink) {
                setSubmenu(false);
            } else {
                setSubmenu(menuItem);
            }
        },
        [menuItem, setSubmenu, submenu?.asLink]
    );

    return (
        <div>
            <div className={css.officeMenuItem}>
                <div
                    onClick={(e) => {
                        handleClick(e, menuItem, openSub, toggleMenu);
                    }}
                    className={classnames(
                        css.officeMenuWrap,
                        submenu && submenu?.asLink === menuItem.asLink ? css.officeMenuWrapOpened : {},
                        isActive ? css.officeMenuWrapActive : {}
                    )}
                >
                    {
                        <div
                            className={
                                submenu.asLink === menuItem.asLink
                                    ? classnames(css.officeMenuItemText, css.officeMenuItemTextActive)
                                    : css.officeMenuItemText
                            }
                        >
                            <div className={css.officeMenuTitleWrap}>
                                <div className={css.officeMenuItemImgWrap}>
                                    {svgSprite(menuItem.icon, {
                                        className: classnames(
                                            css.officeMenuItemImg,
                                            isActive || menuItem?._id === submenu?._id ? css.officeMenuItemImgActive : {}
                                        )
                                    })}
                                </div>
                                <p
                                    className={
                                        isActive || menuItem?._id === submenu?._id
                                            ? classnames(css.officeMenuItemTextP, css.officeMenuItemTextHover)
                                            : css.officeMenuItemTextP
                                    }
                                >
                                    {menuItem.title}
                                </p>
                                <div className={classnames(css.subMenuArrow)}>
                                    {!!menuItem?.submenu?.length &&
                                        svgSprite('angle-right', {
                                            className:
                                                submenu.name === menuItem.name
                                                    ? classnames(css.officeMenuItemArrowMob, css.officeMenuItemArrowMobWeb)
                                                    : css.officeMenuItemArrowMob
                                        })}
                                </div>
                            </div>
                        </div>
                    }
                </div>
                {submenu && submenu?.asLink === menuItem.asLink ? (
                    <div className={css.officeSubMenuMobWrap}>
                        <SubMenuOffice
                            toggleMenu={toggleMenu}
                            menuItem={menuItem}
                            submenu={submenu}
                            active={active}
                            setSubmenu={setSubmenu}
                        />
                    </div>
                ) : null}
            </div>
        </div>
    );
};
export default MenuOfficeItem;
